import { render, staticRenderFns } from "./CartDisplay.vue?vue&type=template&id=5c27e2da&"
import script from "./CartDisplay.vue?vue&type=script&lang=js&"
export * from "./CartDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CartDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports